import React from 'react'
import styled from 'styled-components'

const Input = styled.input`
  border: 1px solid ${({ theme }) => theme.mocaGrey};
  border-radius: 6px;
  font-size: 14px;
  height: 34px;
  width: 100%;
  padding-right: 6px;
  padding-left: 6px;
`

export class EditFormater extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      value: this.props.row[this.props.formatExtraData.field] || ''
    }
  }

  onChange = (value) => this.setState({ value })
  onBlur = () => {
    const { row, rowIndex, formatExtraData: { field, fn, saveOnBlur = true } } = this.props;
    if (saveOnBlur) {
      fn(this.state.value, row, field, rowIndex)
    } else {
      this.onChange(row[field])
      fn(row[field], row, field, rowIndex)
    }
  }
  onEndEditing = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      e.target.blur();
      const { row, rowIndex, formatExtraData: { field, fn } } = this.props;
      fn(this.state.value, row, field, rowIndex)
    }
  }

  render() {
    const {
      type = 'text',
      placeholder,
      field,
      readOnly,
    } = this.props.formatExtraData

    return (<Input
      key={`${this.props.rowIndex}-${field}`}
      readOnly={readOnly}
      placeholder={placeholder}
      type={type}
      value={this.state.value || ''}
      onChange={e => this.onChange(e.target.value)}
      onKeyDown={e => this.onEndEditing(e)}
      onBlur={() => this.onBlur()}
    />)
  }
}
